import gql from 'graphql-tag'

export const SUPPORT_CONVERSATIONS_QUERY = gql`
  query SupportConversations($includeClosed: Boolean) {
    supportConversations(includeClosed: $includeClosed) {
      id
      subject
      status
      lastMessageAt
      messages {
        id
        body
        senderType
        createdAt
      }
      unreadCount
    }
  }
`

export const SUPPORT_CONVERSATION_QUERY = gql`
  query SupportConversation($id: ID!) {
    supportConversation(id: $id) {
      id
      subject
      status
      lastMessageAt
      closedAt
      messages {
        id
        body
        senderType
        senderName
        createdAt
        readAt
        pageContext
        aiConfidence
        closingVariant
        referralSubmission {
          id
          submittedAt
          consentToAttribute
          leadCount
        }
      }
      unreadCount
    }
  }
`

export const UNREAD_COUNT_QUERY = gql`
  query UnreadConversationCount {
    unreadConversationCount
  }
`

export const CONVERSATION_CREATE_MUTATION = gql`
  mutation ConversationCreate($input: ConversationCreateInput!) {
    conversationCreate(input: $input) {
      conversation {
        id
        subject
        status
        lastMessageAt
        messages {
          id
          body
          senderType
          createdAt
        }
      }
      errors {
        attribute
        message
      }
    }
  }
`

export const MESSAGE_CREATE_MUTATION = gql`
  mutation MessageCreate($input: MessageCreateInput!) {
    messageCreate(input: $input) {
      message {
        id
        body
        senderType
        createdAt
      }
      errors {
        attribute
        message
      }
    }
  }
`

export const CONVERSATION_CLOSE_MUTATION = gql`
  mutation ConversationClose($input: ConversationCloseInput!) {
    conversationClose(input: $input) {
      conversation {
        id
        status
        closedAt
      }
      errors {
        attribute
        message
      }
    }
  }
`

export const MESSAGE_RATE_MUTATION = gql`
  mutation MessageRate($input: MessageRateInput!) {
    messageRate(input: $input) {
      message {
        id
        helpful
      }
      errors {
        attribute
        message
      }
    }
  }
`

export const REFERRAL_SUBMISSION_CREATE_MUTATION = gql`
  mutation ReferralSubmissionCreate($input: ReferralSubmissionCreateInput!) {
    referralSubmissionCreate(input: $input) {
      referralSubmission {
        id
        submittedAt
        consentToAttribute
        leadCount
      }
      errors {
        attribute
        message
      }
    }
  }
`
